import React from 'react';
import { Section, Table } from 'Templates'; 

export const Rules = () => (
	<Section title='Rules'>
		<div className='n-flat of-y-auto br-1r'>
			<table className='table-api n-table-bordered n-text-color'>
				<thead>
					<tr>
						<th>Name</th>
						<th className='width-200'>How to use</th>
						<th>Description</th>
						<th className='width-200'>Message</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td> required </td>
						<td> required </td>
						<td> it will require the form field to be filled</td>
						<td> The :attribute field is required </td>
					</tr>
					<tr>
						<td> email </td>
						<td> email </td>
						<td> it will validate if the field contain a valid e-mail</td>
						<td> The :attribute field must be valid email</td>
					</tr>
					<tr>
						<td> min </td>
						<td> min:{'<number>'} </td>
						<td>
							it will validate the minumum character, number, checkbox is
							checked, select(multiple) is selected, file(multiple) is selected.
							<span className='h-word'>e.g. min:10</span>{' '}
						</td>
						<td>
							The :attribute field must be atleast :min (character, items,
							files){' '}
						</td>
					</tr>
					<tr>
						<td> max </td>
						<td> max:{'<number>'} </td>
						<td>
							it will validate the maximum character, number, checkbox is
							checked, select(multiple) is selected, file(multiple) is selected.
							<span className='h-word'>e.g. max:20</span>
						</td>
						<td>
							The :attribute field may not be greater than :max (character,
							items, files)
						</td>
					</tr>
					<tr>
						<td> mimes </td>
						<td> mimes:{'<files mimes>'} </td>
						<td>
							it will validate the specific mimes of the files which are
							allowed.
							<span className='h-word'>e.g. mimes:jpg,pdf,rar</span>
						</td>
						<td> The :attribute only allows :mimes</td>
					</tr>
					<tr>
						<td> alpha </td>
						<td> alpha </td>
						<td>
							{' '}
							it will validate if the field value is only contain letter{' '}
						</td>
						<td> The :attribute may only contain letters</td>
					</tr>
					<tr>
						<td> alpha_space</td>
						<td> alpha_space </td>
						<td>
							{' '}
							it will validate if the field only contain letters with spaces
						</td>
						<td> The :attribute must contain alphabet with spaces </td>
					</tr>
					<tr>
						<td> alpha_num </td>
						<td> alpha_num </td>
						<td> it will validate if the field contain letters with numbers</td>
						<td>The :attribute may only contain letters and numbers.</td>
					</tr>
					<tr>
						<td> alpha_slug </td>
						<td> alpha_slug </td>
						<td>
							it will validate if the field contain letters, numbers, and
							underscore
						</td>
						<td>
							The :attribute may only contain letters, numbers, and underscore.
						</td>
					</tr>
					<tr>
						<td> alpha_dash </td>
						<td> alpha_dash </td>
						<td>
							it will validate if the field contain letters with numbers and
							dashes
						</td>
						<td>
							{' '}
							The :attribute may only contain letters, numbers, and dashes.
						</td>
					</tr>
					<tr>
						<td> url </td>
						<td> url </td>
						<td> it will validate if the field contain valid url</td>
						<td> The :attribute must be a valid url. </td>
					</tr>
					<tr>
						<td> max_size </td>
						<td> max_size:{'<number>'} </td>
						<td>
							it will validate if the field contain a maximum file size and the
							size must calculate in kilobytes.
							<span className='h-word'>e.g. max_size:5000</span>
						</td>
						<td> The :attribute may not be greater :max_size kilobytes.</td>
					</tr>
					<tr>
						<td> min_size </td>
						<td> min_size:{'<number>'} </td>
						<td>
							it will validate if the field contain a minimum file size and the
							size must calculate in kilobytes.
							<span className='h-word'>e.g. min_size:1000</span>
						</td>
						<td>The :attribute must be atleast :min_size kilobytes.</td>
					</tr>
					<tr>
						<td> required_if</td>
						<td>
							required_if:{'<field_id>'}={'<expected_value>'}
						</td>
						<td>
							it will require the field, if the target field matches the
							expected value. you can use exact value or regular expression like
							<span className='h-word'>required_if:bio=.+</span>.{' '}
							<span className='h-word'>.+</span> means has any value.
							<span className='h-word'>e.g. required_if:country=AU</span> since
							most of the time field ids are not the same as the labels and same
							with the values label. that is why you can use Aliasing(@)
							<span className='h-word'>
								e.g. required_if:country@Country=AU@Australia
							</span>
						</td>
						<td>
							The :attribute field is required when :required_if is
							:value.
						</td>
					</tr>
					<tr>
						<td> same </td>
						<td> same:{'<field_id>'} </td>
						<td>
							it will validate the field until the target field contain the same
							value.<span className='h-word'>e.g. same:pass</span> since most of
							the time field ids are not the same as the labels. you can use
							Aliasing(@)<span className='h-word'>e.g. same:pass@Password</span>
						</td>
						<td> The :attribute and :same must match. </td>
					</tr>
				</tbody>
			</table>
		</div>
	</Section>
);

const DoneTypingEventRows = [
	{
		name: 'DoneTypingEvent(',
		type: '',
		default: '',
		description: '',
	},
	{
		name: 'callback,',
		type: 'function',
		default: '-',
		description: 'it is the callback function when the user stop typing.',
		data: [
			{
				name: 'function (',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'event',
				type: 'object',
				default: '-',
				description: 'it consist event properties.',
				data: [
					{
						name: 'type',
						type: 'string',
						default: '-',
						description: 'type of the event triggered.',
					},
					{
						name: 'target',
						type: 'element',
						default: '-',
						description: 'the element which the event happens.',
					},
				],
			},
			{
				name: ') { return void }',
				type: '',
				default: '',
				description: '',
			},
		],
	},
	{
		name: 'delay',
		type: 'number',
		default: '700',
		description:
			'it is the miliseconds aloted for users typing, if its exceeded on aloted time then it will know that the user stops typing.',
	},
	{
		name: ')',
		type: '',
		default: '',
		description: '',
	},
];

const ruleMessage = {
	name: 'message',
	type: 'string',
	default: '-',
	description:
		'it is the message template will be displayed when your rules is invalid.',
	data: [
		{
			name: '`:attribute`',
			type: 'interpulation',
			default: '-',
			description:
				'if it is part of your message, it will be replace by the label you assigned in label schema.',
		},
		{
			name: <pre>`:[ruleName]`</pre>,
			type: 'interpulation',
			default: '-',
			description:
				'if it is part of your message, it will be replace by the parameter you put on the rules like `min:5` then `:min` will be replaced by `5`.',
		},
		{
			name: '`:value`',
			type: 'interpulation',
			default: '-',
			description:
				'if it is part of your message, it will be replace by the value of your parameter like required_if:favorite=apple, then `:value` will be replaced by `apple`.',
		},
	],
};

const rulesExtendRows = [
	{
		name: 'Validator.rulesExtend({',
		type: '',
		default: '',
		description: '',
	},
	{
		name: '[ruleName]',
		type: 'object',
		default: '-',
		description: 'your rule name.',
		data: [
			{
				name: 'exe',
				type: 'function',
				default: '-',
				description:
					'it is where the validation happens, you must return true if the input is invalid.',
				data: [
					{
						name: 'function ({',
						type: '',
						default: '',
						description: '',
					},
					{
						name: 'received,',
						type: 'string | array',
						default: '-',
						description: 'it is the form input`s value.',
					},
					{
						name: 'data,',
						type: 'object',
						default: '-',
						description: 'it is the collected values of all the form fields which is registered in the schema.',
					},
					{
						name: 'parameter,',
						type: 'string',
						default: '-',
						description:
							'it is the parameter of your rule. example `min:5`, the parameter then will be the `5`',
					},
					{
						name: 'parameter_value',
						type: 'string',
						default: '-',
						description:
							'when your rule had a parameter and the parameter had a value, then it will be it. example `required_if:job=programmer`, the value then will be the `programmer`',
					},
					{
						name: '}) { return boolean }',
						type: '',
						default: '',
						description: '',
					},
				],
			},
			ruleMessage,
			{
				name: 'allowMessageEvenValid',
				type: 'boolean',
				default: 'false',
				description: 'it is use to allow message to be process and displayed even the received value is valid.',
			}
		],
	},
	{
		name: '})',
		type: '',
		default: '',
		description: '',
	},
];

const rulesUpdateMessageRows = [
	{
		name: 'Validator.rulesUpdateMessage({',
		type: '',
		default: '',
		description: '',
	},
	{
		name: 'ruleName,',
		type: 'string',
		default: '-',
		description: 'the name of the rule you want to update the message',
	},
	ruleMessage,
	{
		name: '})',
		type: '',
		default: '',
		description: '',
	},
];

const Redundant = [
	{
		name: 'formState,',
		type: 'function',
		default: '-',
		description: 'it is use to fetch the field state.',
		data: [
			{
				name: 'const fieldState = formState(',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'fetchState',
				type: 'string | array',
				default: '-',
				description: 'it is the name of the field which is registered on the schema. furthermore you can passed an array to fetch multiple field states.',
			},
			{
				name: ')',
				type: '',
				default: '',
				description: '',
			},
		]
	},
	{
		name: 'formUpdate,',
		type: 'function',
		default: '-',
		description: 'it is use to update the field state. and it is commonly used directly in onChange event or if more complex you can use it inside the EventHandler.',
		data: [
			{
				name: 'formUpdate(',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'event,',
				type: 'Event | object',
				default: '-',
				description: 'it is the event of the EventListener or alternative imitation of it.',
				data: [
					{
						name: 'target',
						type: 'element | object',
						default: '-',
						description: 'if you want to imitate the form element. the object must contain property type, value, and name.',
					},
				]
			},
			{
				name: 'directKey?',
				type: 'string',
				default: '-',
				description: 'it is use as a direct access key, to directly tell formUpdate which field state will be updated, and will not depend on the form field attribute name when the event is triggered.',
			},
			{
				name: ')',
				type: '',
				default: '',
				description: '',
			},
		]
	},
	{
		name: 'formRegistry,',
		type: 'function',
		default: '-',
		description: 'it is use to remotely register the field rules into the schema.',
		data: [
			{
				name: 'formRegistry({',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'name,',
				type: 'string',
				default: '-',
				description: 'it is the name of the form field.',
			},
			{
				name: 'label,',
				type: 'string',
				default: '[name]',
				description: 'it is the label of the form field you want to display in the invalid messages.',
			},
			{
				name: 'rules,',
				type: 'string',
				default: '-',
				description: 'it is the rules you want to set for form field.',
			},
			{
				name: 'value?,',
				type: 'string',
				default: '-',
				description: 'it is the default value you want to set on the form field.',
			},
			{
				name: 'aliased?',
				type: 'string',
				default: '-',
				description: 'it is used as an alternative name or identifier of the form field which have a similar name.',
			},
			{
				name: '})',
				type: '',
				default: '',
				description: '',
			},
		]
	}
]

const useFormRows = [
	{
		name: 'const {',
		type: '',
		default: '',
		description: '',
	},
	...Redundant,
	{
		name: 'formSubmit',
		type: 'function',
		default: '-',
		description: 'it is use to handle the submission of form field.',
		data: [
			{
				name: 'const submitHandler = formSubmit(',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'callback',
				type: 'function',
				default: '-',
				description: 'it is the callback function which will be executed each time the form is submited.',
				data: [
					{
						name: 'function (',
						type: '',
						default: '',
						description: '',
					},
					{
						name: 'event',
						type: 'FormEvent',
						default: '-',
						description: 'it is consist of methods which is use to submit.',
						data: [
							{
								name: 'event.target',
								type: 'element',
								default: '-',
								description: 'It will get the form element.',
							},
							{
								name: 'event.locateFailed()',
								type: 'method',
								default: '-',
								description: 'It will locate the form field that fails the requirements if the field is out of the view point. you can adjust the position by passing a int parameter .locateFailed(70) the default is 40 depends on your navbar height if it is fixed and if you just want to get the scrollTop just do .locateFailed(70, false)',
								data: [
									{
										name: 'event.locateFailed(',
										type: '',
										default: '',
										description: '',
									}, 
									{
										name: 'prefix,',
										type: 'number',
										default: '40',
										description: 'it is the additional top position when the navbar is fixed.',
									},
									{
										name: 'autoscroll',
										type: 'boolean',
										default: 'true',
										description: <>if you just want to get the scrollTop just assign <b>false</b>.</>,
									},
									{
										name: '): number',
										type: '',
										default: '',
										description: '',
									},
								]
							},
							{
								name: 'event.reset()',
								type: 'method',
								default: '-',
								description: 'It will reset all the form fields and the schema.',
							},
							{
								name: 'event.isReady()',
								type: 'method',
								default: '-',
								description: 'It will check if the form is ready and all the value is valid.',
							},
							{
								name: 'event.json()',
								type: 'method',
								default: '-',
								description: <>It will return the form data in json. that is use for <b>Content-Type: application/json</b>.</>,
							},
							{
								name: 'event.paramArray()',
								type: 'method',
								default: '-',
								description: 'It will return the form data in array.',
							},
							{
								name: 'event.param()',
								type: 'method',
								default: '-',
								description: <>It will return the form data in url encode string that is use for <b>Content-Type: application/x-www-form-urlencoded</b>.</>,
							},
							{
								name: 'event.formData()',
								type: 'method',
								default: '-',
								description: 'it will return instance of FormData.',
							},
							{
								name: 'event.forEach',
								type: 'method',
								default: '-',
								description: 'it will loop each of the form data.',
							},
						]
					},
					{
						name: ') { return void }',
						type: '',
						default: '',
						description: '',
					},
				]
			},
			{
				name: ')',
				type: '',
				default: '',
				description: '',
			},
		]
	},
	{
		name: '} = useForm(',
		type: '',
		default: '',
		description: '',
	},
	{
		name: 'schema?',
		type: 'object',
		default: '-',
		description: 'it is the pre-registration of the fields.',
		data: [
			{
				name: '{',
				type: '',
				default: '',
				description: '',
			},
			{
				name: '[fields name]:',
				type: 'object',
				default: '-',
				description: 'it is the object-key of your field state.',
				data: [ 
					{
						name: 'label,',
						type: 'string',
						default: '[fields name]',
						description: 'it is the label of the form field you want to display in the invalid messages.',
					},
					{
						name: 'rules,',
						type: 'string',
						default: '-',
						description: 'it is the rules you want to set for form field.',
					},
					{
						name: 'value?,',
						type: 'string',
						default: '-',
						description: 'it is the default value you want to set on the form field.',
					},
					{
						name: 'aliased?',
						type: 'string',
						default: '-',
						description: 'it is used as an alternative name or identifier of the form field which have a similar name.',
					},
				]
			},
			{
				name: '}',
				type: '',
				default: '',
				description: '',
			},
			
		]
	},
	{
		name: ')',
		type: '',
		default: '',
		description: '',
	},
]

const FormSupplierRows = [
	{
		name: 'value',
		type: 'object',
		default: '-',
		description: 'it must contain the useForm funtions: formState, formUpdate, and formRegistry which will be supply to all of its descendant using useFormSupplier.',
		data: Redundant
	},
]

const useFormSupplierRows = [
	{
		name: 'const {',
		type: '',
		default: '',
		description: '',
	},
	...Redundant,
	{
		name: '} = useFormSupplier()',
		type: '',
		default: '',
		description: '',
	}
]

export const DoneTypingEvent = () => (
	<Section
		title='DoneTypingEvent'
		context='it is use to fire the event after user done typing, that will save a lot of unessesary execution while typing.'>
		<Table.ForAPI data={DoneTypingEventRows} />
	</Section>
);

export const rulesExtend = () => (
	<Section
		title='Validator.rulesExtend'
		context='it is use to make your own rules.'>
		<Table.ForAPI data={rulesExtendRows} />
	</Section>
);

export const rulesUpdateMessage = () => (
	<Section
		title='Validator.rulesUpdateMessage'
		context='it is use to change the message of the existing rules.'>
		<Table.ForAPI data={rulesUpdateMessageRows} />
	</Section>
);

export const useForm = () => (
	<Section
		title='useForm'
		context='it is use to register schema and to get formState, formUpdate, formSubmit, formRegistry.'>
		<Table.ForAPI data={useFormRows} />
	</Section>
);


export const FormSupplier = () => (
	<Section
		title='FormSupplier'
		context='it is use to set the useForm functions into useFormSupplier which you can use under FormSupplier as a wrapper.'>
		<Table.ForAPI data={FormSupplierRows} />
	</Section>
);

export const useFormSupplier = () => (
	<Section
		title='useFormSupplier'
		context='it is use to fetch FormSupplier provided.'>
		<Table.ForAPI data={useFormSupplierRows} />
	</Section>
);